import { Section } from "@app/core/match/domain/model/section.v2";

export const fakeSections: Section[] = [
  {
    id: "positioning",
    title: "Your positioning **",
    info: null,
    layout: { kind: "flex_scroll" },
    tabs: null,
    blocks: [
      {
        id: "court_coverage",
        type: "chart_line",
        layout: { order: 1, colSpan: { sm: 11, xl: 6 } },
        title: "Court coverage **",
        info: "Percentage of time in which player is positioned horizontally / vertically (voley-back) on the court in an adequate way to maximize the probability of finishing the point or defending it, with respect to the positioning of the opponents. As a reference, in the professional padel finals, both in the men’s and women’s categories, players reach between 85 and 95% of good horizontal coverage.",
        data: {
          x: {
            label: null,
            ticks: ["2025-12-27", "2026-01-19", "2026-02-02"],
          },
          y: {
            label: null,
            unit: "%",
            min: 50,
            max: 100,
            interval: 20,
          },
          series: [
            {
              id: "basculacio_horitzontal_individual",
              name: "% good horizontal coverage",
              color: "#9ADBEF",
              values: [
                { raw: 90, display: ">90%", unit: "%" },
                { raw: 82, display: "82%", unit: "%" },
                { raw: 86, display: "86%", unit: "%" },
              ],
            },
            {
              id: "basculacio_vertical_individual",
              name: "% good vertical coverage",
              color: "#52AFD0",
              values: [
                { raw: 76, display: "76%", unit: "%" },
                { raw: 69, display: "69%", unit: "%" },
                { raw: 82, display: "82%", unit: "%" },
              ],
            },
          ],
        },
      },

      {
        id: "team_coordination",
        type: "chart_line",
        layout: { order: 2, colSpan: { sm: 11, xl: 6 } },
        title: "Team coordination **",
        info: "Percentage of time that both team players have been vertically / horizontally coordinated. As a reference, in the professional padel finals players reach between 85 and 90% of good vertical / horizontal coordination.",
        data: {
          x: {
            label: null,
            ticks: ["2025-12-27", "2026-01-19", "2026-02-02"],
          },
          y: {
            label: null,
            unit: "%",
            min: 40,
            max: 80,
            interval: 4,
          },
          series: [
            {
              id: "pct_basc_hor",
              name: "% good horizontal coordination",
              color: "#408FA2",
              values: [
                { raw: 69, display: "69%", unit: "%" },
                { raw: 65, display: "65%", unit: "%" },
                { raw: 69, display: "69%", unit: "%" },
              ],
            },
            {
              id: "pct_basc_vertical",
              name: "% good vertical coordination",
              color: "#52AFD0",
              values: [
                { raw: 70, display: "70%", unit: "%" },
                { raw: 52, display: "52%", unit: "%" },
                { raw: 59, display: "59%", unit: "%" },
              ],
            },
          ],
        },
      },

      {
        id: "court_zones",
        type: "chart_bar_stacked",
        layout: { order: 3, colSpan: { sm: 11, xl: 12 } },
        title: "% of time in each court zone **",
        info: "Percentage of match time that the player has been in the volley area (between 0 and 5 meters away from the net), in the transition zone (from 5 to 7 meters away from the net), and in the back (behind the service zone). As a reference, in the professional padel finals, both male and female players achieve between a 45 and 50% in volley, around a 15% in transition, and between 35 and 40% at the back.",
        data: {
          x: {
            label: null,
            ticks: ["2025-12-27", "2026-01-19", "2026-02-02"],
          },
          y: {
            unit: "%",
            min: null,
            max: null,
          },
          stacks: [
            {
              id: "pct_fondo",
              name: "Back",
              color: "#408FA2",
              values: [52, 74, 53],
            },
            {
              id: "pct_transicion",
              name: "Transition",
              color: "#52AFD0",
              values: [15, 16, 19],
            },
            {
              id: "pct_volea",
              name: "Volley",
              color: "#9ADBEF",
              values: [33, 10, 28],
            },
          ],
        },
      },
    ],
  },

  // ---------------------------
  // YOUR STROKES
  // ---------------------------
  {
    id: "strokes",
    title: "Your strokes **",
    info: null,
    layout: { kind: "flex_scroll" },
    tabs: null,
    blocks: [
      {
        id: "efectivitat_colocacio",
        type: "chart_line",
        layout: { order: 1, colSpan: { sm: 11, xl: 6 } },
        title: "Hits aimed at uncovered areas **",
        info: "Percentage of player's strokes that have forced the opponent to move 2 or more meters to return the ball (or try to do so, in case he/she has not succeeded). As a reference, in the professional padel finals, in both men's and women's categories, players reach between a 40 and 50%.",
        data: {
          x: {
            label: null,
            ticks: ["2025-12-27", "2026-01-19", "2026-02-02"],
          },
          y: {
            label: null,
            unit: "%",
            min: 10,
            max: 50,
            interval: 4,
          },
          series: [
            {
              id: "efectivitat_colocacio",
              name: "% of hits",
              color: "#408FA2",
              values: [
                { raw: 37, display: "37%", unit: "%" },
                { raw: 18, display: "18%", unit: "%" },
                { raw: 31, display: "31%", unit: "%" },
              ],
            },
          ],
        },
      },

      {
        id: "efectivitat_colocacio_companero",
        type: "chart_bar_stacked",
        layout: { order: 2, colSpan: { sm: 11, xl: 6 } },
        title: "% of hits per player of the team **",
        info: "Percentage of times that each team player (and of the opposing team) has hit the ball, in respect to the team’s total.",
        data: {
          x: {
            label: null,
            ticks: ["2025-12-27", "2026-01-19", "2026-02-02"],
          },
          y: {
            unit: "%",
            min: null,
            max: null,
          },
          stacks: [
            {
              id: "pct_posesion",
              name: "User",
              color: "#408FA2",
              values: [43, 62, 51],
            },
            {
              id: "pct_posesion_companero",
              name: "Teammate",
              color: "#52AFD0",
              values: [57, 38, 49],
            },
          ],
        },
      },

      {
        id: "velo_bandeja",
        type: "chart_line",
        layout: { order: 3, colSpan: { sm: 11, xl: 4 } },
        title: "Your attack power — Bandeja speed **",
        info: "Average speed in km/h of the player’s smashes, bandejas and volleys.",
        data: {
          x: { label: null, ticks: ["2025-12-27", "2026-01-19", "2026-02-02"] },
          y: { label: null, unit: "km/h", min: 40, max: 80 },
          series: [
            {
              id: "velo_bandeja",
              name: "Bandeja",
              color: "#52AFD0",
              values: [
                { raw: 56, display: "56 km/h", unit: "km/h" },
                { raw: 54, display: "54 km/h", unit: "km/h" },
                { raw: 67, display: "67 km/h", unit: "km/h" },
              ],
            },
          ],
        },
      },

      {
        id: "velo_remat",
        type: "chart_line",
        layout: { order: 4, colSpan: { sm: 11, xl: 4 } },
        title: "Your attack power — Smash speed **",
        info: "Average speed in km/h of the player’s smashes, bandejas and volleys.",
        data: {
          x: { label: null, ticks: ["2025-12-27", "2026-01-19", "2026-02-02"] },
          y: { label: null, unit: "km/h", min: 60, max: 100 },
          series: [
            {
              id: "velo_remat",
              name: "Smash",
              color: "#408FA2",
              values: [
                { raw: 66, display: "66 km/h", unit: "km/h" },
                { raw: 67, display: "67 km/h", unit: "km/h" },
                { raw: 90, display: "90 km/h", unit: "km/h" },
              ],
            },
          ],
        },
      },

      {
        id: "velo_volea",
        type: "chart_line",
        layout: { order: 5, colSpan: { sm: 11, xl: 4 } },
        title: "Your attack power — Volley speed **",
        info: "Average speed in km/h of the player’s smashes, bandejas and volleys.",
        data: {
          x: { label: null, ticks: ["2025-12-27", "2026-01-19", "2026-02-02"] },
          y: { label: null, unit: "km/h", min: 30, max: 50 },
          series: [
            {
              id: "velo_volea",
              name: "Volley",
              color: "#408FA2",
              values: [
                { raw: 43, display: "43 km/h", unit: "km/h" },
                { raw: 41, display: "41 km/h", unit: "km/h" },
                { raw: 42, display: "42 km/h", unit: "km/h" },
              ],
            },
          ],
        },
      },
    ],
  },

  // ---------------------------
  // YOUR SERVES AND RETURNS
  // ---------------------------
  {
    id: "serves_and_returns",
    title: "Your serves and returns **",
    info: null,
    layout: { kind: "flex_scroll" },
    tabs: null,
    blocks: [
      {
        id: "pct_primeros_saques",
        type: "chart_line",
        layout: { order: 1, colSpan: { sm: 11, xl: 6 } },
        title: "% first serves **",
        info: "Percentage of serves in which the first serve has been valid. As a reference, in the professional padel finals, in both the men’s and women’s categories, the first serve percentage is around 90-95%.",
        data: {
          x: {
            label: null,
            ticks: ["2025-12-27", "2026-01-19", "2026-02-02"],
          },
          y: {
            label: null,
            unit: "%",
            min: 60,
            max: 100,
            interval: 4,
          },
          series: [
            {
              id: "pct_primeros_saques",
              name: "% 1st serves",
              color: "#9ADBEF",
              values: [
                { raw: 67, display: "67%", unit: "%" },
                { raw: 71, display: "71%", unit: "%" },
                { raw: 100, display: "100%", unit: "%" },
              ],
            },
          ],
        },
      },

      {
        id: "pct_segundos_saques",
        type: "chart_bar_stacked",
        layout: { order: 2, colSpan: { sm: 11, xl: 6 } },
        title: "Serve placement **",
        info: "Percentage of your serves of the player which have been hit to central zone (T zone), opponent's body or lateral wall.",
        data: {
          x: {
            label: null,
            ticks: ["2025-12-27", "2026-01-19", "2026-02-02"],
          },
          y: {
            unit: "%",
            min: null,
            max: null,
          },
          stacks: [
            {
              id: "pct_saques_m",
              name: "% to opponent's body",
              color: "#52AFD0",
              values: [15, 44, 5],
            },
            {
              id: "pct_saques_t",
              name: "% to the center (T zone)",
              color: "#408FA2",
              values: [33, 8, 21],
            },
            {
              id: "pct_saques_x",
              name: "% to lateral wall",
              color: "#9ADBEF",
              values: [52, 48, 74],
            },
          ],
        },
      },

      {
        id: "velocidadsaques",
        type: "chart_line",
        layout: { order: 3, colSpan: { sm: 11, xl: 12 } },
        title: "Serves' speed **",
        info: "Average speed in km/h of the player’s serves. As a reference, in the professional padel finals, both in the men’s and women’s categories, the serve speed is between 60 and 70 km/h.",
        data: {
          x: {
            label: null,
            ticks: ["2025-12-27", "2026-01-19", "2026-02-02"],
          },
          y: {
            label: null,
            unit: "km/h",
            min: 30,
            max: 60,
            interval: 4,
          },
          series: [
            {
              id: "velocidadsaques",
              name: "Average speed",
              color: "#408FA2",
              values: [
                { raw: 54, display: "54 km/h", unit: "km/h" },
                { raw: 43, display: "43 km/h", unit: "km/h" },
                { raw: 51, display: "51 km/h", unit: "km/h" },
              ],
            },
          ],
        },
      },
    ],
  },
];

export default fakeSections;
